export enum AssetType {
  Folder = 'folder',
  Asset = 'asset'
}

export enum MediaType {
  Video = 'video',
  Audio = 'audio',
  Picture = 'picture',
  Project = 'pr_project',
  Document = 'document',
  Other = 'other',
  Note = 'note'
}
